import { createUseStyles } from 'react-jss'
import { addProps, addDisplayName, addHandlers, addRef, flowMax } from 'ad-hok'
import { ChangeEvent, FC } from 'react'
import { addApi, addUser } from 'shared/src/api'
import { typedAs } from 'shared/src/utils/typedAs'
import { branchIfFailsPredicate } from 'ad-hok-utils'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { Button } from './Button'

const useStyles = createUseStyles({
  input: {
    display: 'none',
  },
})

export const ProductsExtraButtons: FC = flowMax(
  addDisplayName('ProductsUploader'),
  addApi,
  addUser,
  branchIfFailsPredicate('user', (user) => user.isAdmin),
  addRef('ref', typedAs<HTMLInputElement | null>(null)),
  addTranslationHelpers,
  addHandlers({
    onImport:
      ({ ref }) =>
      () => {
        ref.current?.click()
      },
    uploadCsv:
      ({ api, t }) =>
      async (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if (!files || files.length === 0) {
          return
        }

        const file = files[0]

        try {
          await api.products.import(file)
          alert(t('admin.resources.products.uploadCsvSuccess'))
        } catch (error) {
          alert(t('admin.resources.products.uploadCsvError'))
        }
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ onImport, uploadCsv, ref, classes, t }) => (
    <>
      <Button
        text={t('admin.resources.products.uploadCsv')}
        onClick={onImport}
      />
      <input
        type="file"
        accept=".csv"
        onChange={uploadCsv}
        ref={ref}
        className={classes.input}
      />
    </>
  )
)
